import { getElements } from './utils';

const iOSSafari = (userAgent) => {
  return /iP(ad|od|hone)/i.test(userAgent) && /WebKit/i.test(userAgent) && !/(CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent);
};
export const cardFlipOnSafari = () => {
  if (iOSSafari(window.navigator.userAgent) || window.safari !== undefined) {
    let css = '.flip-card-inner {  transition: transform 0s ease-in-out !important; }',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');

    head.appendChild(style);

    console.log('safari');
    style.type = 'text/css';
    if (style.styleSheet) {
      // This is required for IE8 and below.
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
};

// card flip on click
export const cardFlipOnClick = () => {
  if (window.innerWidth >= 992) {
    let cards = getElements('.flip-card');
    Array.from(cards).forEach((card) => {
      card.addEventListener('click', () => {
        card.classList.toggle('active');
      });
    });
  }
};
